import React from "react";

export default function Footer() {
  return (
    <div className="w-[100vw] bg-[#050402]">
      <div className="w-[90%] m-auto flex items-center bg-[#050402] h-20">
        {/* <img
          src="https://i.pinimg.com/564x/ae/f6/d0/aef6d084d09af1779ae1fb640d39a970.jpg"
          alt="footer"
          className="h-20 m-8"
        ></img> */}
        <span className="text-[#FFFFFF] m-[-40px] font-bold text-[25px] ">
          R E C I P E R
        </span>
      </div>
    </div>
  );
}
